import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Button, message } from "antd";
import { useTranslation } from "react-i18next";
import Step1 from "./ExamSteps/step1";
import Step2 from "./ExamSteps/step2";
import Step3 from "./ExamSteps/step3";
import { getRequest, postRequest } from "../../services/index";

const GenerateExam = ({ onRequestClose, selectedBookId }) => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(1);
  const [bookDetails, setBookDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedSubLessons, setSelectedSubLessons] = useState([]);
  const [selectChapter, setSelectChapter] = useState([]);
  const [displyBtn, setDisplayBtn] = useState(true);
  const [randomQuestions, setRandomQuestions] = useState([]);
  const [paperInfo, setPaperInfo] = useState([]);

  useEffect(() => {
    
    if (selectedBookId) {
      fetchBookDetails();
    }
  }, [selectedBookId]);

  const fetchBookDetails = async () => {
    try {
      setLoading(true);
      const response = await getRequest(`/api/PaperGeneration/book-detail/${selectedBookId}`);
      if (response.data) {
        setBookDetails(response.data);
      }
    } catch (error) {
      message.error('Failed to fetch book details');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (onRequestClose) {
      onRequestClose();
    }
  };

  const handleNextStep = () => {
    setCurrentStep((prevStep) => Math.min(prevStep + 1, 3));
    if(currentStep === 1)
    {
      setDisplayBtn(false);
    }
    else{
      setDisplayBtn(true);
    }
  };

  const handlePreviousStep = () => {
    setCurrentStep((prevStep) => Math.max(prevStep - 1, 1));
    if(currentStep === 1)
      {
        setDisplayBtn(false);
      }
      else{
        setDisplayBtn(true);
      }
  };
  const handleSave = async () => {
    try {
      const payload = {
        ClassName: paperInfo.class,
        SubjectName: paperInfo.subject,
        questionType: paperInfo.questionType,
        marksPerQuestion: paperInfo.eachQuestionMarks,
        questionCount: randomQuestions.length,
        paperJson: JSON.stringify(randomQuestions),
        examType: paperInfo.examFrom,
        questionPerLine: paperInfo.questionPerLine,
        dokLevel: paperInfo.dokLevel
      };

      const response = await postRequest('/api/PaperGeneration/save-generated-paper', payload);
      if (response) {
        message.success('Paper saved successfully');
        handleClose();
      }
    } catch (error) {
      console.error('Error saving paper:', error);
      message.error('Failed to save paper');
    }
  };

  return (
    <div className="container-fluid p-0 m-0 pb-4">
      <div className="row d-flex justify-contents-center p-0 m-0">
        <div className="col-md-12 examModalWrapper p-0 m-0">
          <div className="d-flex justify-content-between align-items-center px-4 col-md-12 examModalHeader">
            <h4 style={{ color: "#060317" }} className="fw-bold">{t("SelectSyllabus")}</h4>
            <div className="iconWrapper cursor-pointer" onClick={handleClose}><X /></div>
          </div>
        </div>  
      </div>
      <div className="modalBody p-4">
        <div className="mb-4">
          <div className="progressWrapper ">
            <div className="progressNumbering" style={{ width: `${(currentStep - 1) * 50}%` }}></div>
            <div className={`stepNumber ${currentStep >= 1 ? "active" : ""}`}>1</div>
            <div className={`stepNumber ${currentStep >= 2 ? "active" : ""}`}>2</div>
            <div className={`stepNumber ${currentStep >= 3 ? "active" : ""}`}>3</div>
          </div>
          {currentStep === 1 && (
            <Step1 selectedSubLessons={selectedSubLessons} setSelectedSubLessons={setSelectedSubLessons} bookDetails={bookDetails} selectChapter={selectChapter} setSelectChapter={setSelectChapter} loading={loading} />
          )}
          {currentStep === 2 && (
            <Step2 selectedBookId={selectedBookId} selectedSubLessons={selectedSubLessons} selectChapter={selectChapter} setDisplayBtn={setDisplayBtn} randomQuestions={randomQuestions} setRandomQuestions={setRandomQuestions} 
            setPaperInfo={setPaperInfo}/>
          )}
          {currentStep === 3 && (
            <Step3 paperInfo={paperInfo} randomQuestions={randomQuestions}  />
          )}
        </div>
      </div>
      
      <div className="col-md-12 px-4 mt-3 py-3">
        <div className="d-flex gap-3 justify-content-end">
          <div onClick={handleClose}>
            <Button type="default">{t("Cancel")}</Button>
          </div>
          {currentStep > 1 && (
            <Button type="default" onClick={handlePreviousStep}>
              {t("Previous")}
            </Button>
          )}
          {currentStep < 3 && displyBtn && (
            <Button type="primary" onClick={handleNextStep}>
              {t("Next")}
            </Button>
          )}
          {currentStep === 3 && (
            <Button type="primary" onClick={handleSave}>
              {t("Save")}
            </Button>
          )}
        </div>
      </div>
     
    </div>
  );
};

export default GenerateExam;